import { render, staticRenderFns } from "./OnsiteInitiaatorDashboard.vue?vue&type=template&id=70941515&scoped=true"
import script from "./OnsiteInitiaatorDashboard.vue?vue&type=script&lang=js"
export * from "./OnsiteInitiaatorDashboard.vue?vue&type=script&lang=js"
import style0 from "./OnsiteInitiaatorDashboard.vue?vue&type=style&index=0&id=70941515&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70941515",
  null
  
)

export default component.exports